import { Card, CardContent } from '@iptv/ui';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { adminFetch } from '../lib/api';

interface SiteAdmin {
  id: number;
  slug: string;
  domain: string;
  theme: string;
  default_locale: string;
  active: boolean;
}

export function SitesPage() {
  const sites = useQuery({
    queryKey: ['admin', 'sites'],
    queryFn: () => adminFetch<SiteAdmin[]>('/api/v1/admin/sites'),
  });

  if (sites.isPending) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {sites.data?.map((site) => (
        <Link key={site.id} to={`/sites/${site.id}`} className="block">
          <Card className="transition hover:border-primary">
            <CardContent className="p-4">
              <div className="text-xs uppercase tracking-wider text-muted-foreground">
                {site.theme}
              </div>
              <div className="text-lg font-semibold">{site.slug}</div>
              <div className="mt-1 text-sm text-muted-foreground">{site.domain}</div>
              <div className="mt-2 text-xs text-muted-foreground">
                Locale: {site.default_locale} · {site.active ? 'Active' : 'Disabled'}
              </div>
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  );
}
